function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "user",
  d: "M3.534,10.07a1,1,0,1,1,.733,1.86A3.579,3.579,0,0,0,2,15.26V17a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V15.353a3.658,3.658,0,0,0-2.357-3.419,1,1,0,1,1,.713-1.868A5.658,5.658,0,0,1,14,15.353V17a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V15.26a5.579,5.579,0,0,1,3.533-5.19ZM7,0a4,4,0,0,1,4,4V6A4,4,0,0,1,3,6V4A4,4,0,0,1,7,0ZM7,2A2,2,0,0,0,5,4V6A2,2,0,0,0,9,6V4A2,2,0,0,0,7,2Z",
  fill: "#fff"
});

function SvgIcHabitUserActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHabitUserActive);
export default ForwardRef;